import React from 'react';
import Grid from '@material-ui/core/Grid';
import { TreemapChart } from 'app/components/Charts/treemap';
import { TreemapDataModel } from 'app/components/Charts/treemap/data';
import { PublishersFragmentTable } from 'app/fragments/publishers-fragment/common/table';

interface PublishersFragmentLayoutProps {
  showViz: boolean;
  pageParam: string;
  detailBaseFilter: string;
  treemapData: TreemapDataModel;
}

export const PublishersFragmentLayout = (
  props: PublishersFragmentLayoutProps
) => {
  return (
    <>
      <Grid item sm={12} md={12} lg={12}>
        {props.showViz ? (
          <TreemapChart
            aria-label="Treemap showing total budget divided by publishers."
            label="Publishers"
            data={props.treemapData}
            pageParam={props.pageParam}
            detailBaseFilter={props.detailBaseFilter}
          />
        ) : (
          <PublishersFragmentTable
            pageParam={props.pageParam}
            detailBaseFilter={props.detailBaseFilter}
          />
        )}
      </Grid>
    </>
  );
};
